import * as React from "react";
import { Row, Col, Button } from 'antd';
import { PbrInput } from '../../PbrInput/PbrInput';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import "./confirmPassword.scss"
import { useState } from "react";

const compareToFirstPassword = (props) => {
    return (rule, value, callback) => {
        const form = props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('As senhas estão diferentes!');
        } else {
            callback();
        }
    };
}

interface IConfirmPassword {
    form: WrappedFormUtils;
    label: string;
    placeholder: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function ConfirmPassword(props: IConfirmPassword) {
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(s => !s);
    };

    return (
        <Row className="confirm-password">
            <Col xs={24} md={24}>
                <div style={{ position: 'relative' }}>
                    <PbrInput
                        name="password"
                        type="password" placeholder={props.placeholder}
                        formItemProps={{ label: props.label }}
                        formWrapper={props.form}
                        rules={[
                            { required: true, message: "A senha é obrigatória!" },
                            {
                                pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[@#$%^&+=]).{8,}$/,
                                message: "A senha deve conter no mínimo 8 caracteres, uma letra maíuscula, uma minúscula, 1 número e um caractere especial (@#$%^&+=)"
                            }]
                        }
                        onChange={props.onChange}
                    />
                    <Button
                        onClick={handleShowPassword}
                        style={{
                            position: 'absolute',
                            right: 1,
                            top: 39,
                            border: 'none'
                        }}
                        icon={showPassword ? "eye-invisible" : "eye"}
                    />
                </div>
                <div style={{ position: 'relative' }}>
                    <PbrInput
                        name="confirmPassword"
                        type="password"
                        placeholder={props.placeholder ? "Confirme a senha" : ""}
                        formWrapper={props.form}
                        formItemProps={{ label: props.label ? "Confirme sua senha" : "" }}
                        rules={[{ required: true, message: 'Por favor, confirme a senha!' }, { validator: compareToFirstPassword(props) }]}
                    />
                    <Button
                        onClick={handleShowPassword}
                        style={{
                            position: 'absolute',
                            right: 1,
                            top: 1,
                            border: 'none'
                        }}
                        icon={showPassword ? "eye-invisible" : "eye"}
                    />
                </div>
            </Col>
        </Row>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/Form/ConfirmPassword/ConfirmPassword.tsx